import { DeviceEnum } from './plan-request';


/**
* Clone case model.
*/
export interface CloneCase {
	/**
	* Received send case GUID to clone.
	*/
	caseId: string;
	/**
	* New plan number to set on cloned case.
	*/
	caseNumber: string;
	/**
	* Note to set on cloned case.
	*/
	caseNote?: string;
	/**
	* Optional patient GUID to associate the cloned case with.
	*/
	patientId?: string;
	/**
	* Optional new patient number to set on cloned case; when patient GUID not specified.
	*/
	patientNumber?: string;
	/**
	* Optional new patient initials to set on cloned case; when patient GUID not specified.
	*/
	patientInitials?: string;
	/**
	 * Optional new frame ID to set on cloned case.
	 */
	frameID?: FrameIDTypeEnum;
	/**
	 * Optional device to assign to the case to migrate if in TBD condition.
	 */
	device?: DeviceEnum;
}

export enum FrameIDTypeEnum {
	A = 'A',
	B = 'B',
	C = 'C',
	D = 'D',
	E = 'E',
	F = 'F'
}

export const FRAME_LIST: FrameIDTypeEnum[] = Object.values(FrameIDTypeEnum);
